/**
 * Qual versão do ERP esta aba está rodando e qual está publicada.
 *
 * Todo deploy publica um `asset-manifest.json` novo (sem cache no S3 e
 * invalidado no CloudFront) com o nome do bundle principal, que tem o hash
 * do conteúdo: `/static/js/main.aba17071.js`. A aba aberta sabe qual bundle
 * carregou (a tag <script> do index.html). Nomes diferentes = há versão nova.
 *
 * O service worker do ERP é um arquivo fixo (public/service-worker.js) que
 * não muda a cada deploy, então ele não serve de sinal (no Cut, que gera o
 * SW no build, serve).
 */

const BUNDLE_PRINCIPAL = /\/static\/js\/main\.[^/]+\.js$/;

/** Caminho do bundle principal publicado, ou null se o manifesto não tiver. */
export function bundleDoManifesto(manifesto) {
  const caminho = manifesto?.files?.["main.js"];
  return typeof caminho === "string" && BUNDLE_PRINCIPAL.test(caminho) ? caminho : null;
}

/** Caminho do bundle principal que esta página carregou, ou null (dev server). */
export function bundleCarregado(documento = document) {
  const script = [...documento.querySelectorAll("script[src]")]
    .map((tag) => {
      try {
        return new URL(tag.getAttribute("src"), documento.baseURI).pathname;
      } catch (erro) {
        // src inválido não é o bundle do app; segue procurando.
        return null;
      }
    })
    .find((caminho) => caminho && BUNDLE_PRINCIPAL.test(caminho));
  return script || null;
}

/** Só acusa versão nova quando os dois lados são conhecidos e diferem. */
export function haVersaoNova(carregado, publicado) {
  return Boolean(carregado && publicado && carregado !== publicado);
}
